$(document).ready(function() {
    "use strict";

    $(document).on('ready', function () {
        var $viberModal = $('#viber-modal');

        if ($viberModal.length) {
            Modal.openModal('viber-modal');

            $viberModal.find('.i-viber-action').on('click', function() {
                var url = $(this).data('url');

                $.ajax({
                    url:  url,
                    data: {'experiment': $(this).data('experiment')},
                    type: 'POST',
                    dataType: 'json',
                })
                    .fail(function (xhr) {
                        var errorMessage = 'Что-то пошло не так, попробуйте позднее';

                        if (typeof(xhr.responseJSON) != 'undefined' && typeof(xhr.responseJSON.error) != 'undefined') {
                            errorMessage = JSON.parse(xhr.responseText).error;
                        }

                        Toasts.pushToast(errorMessage, 'fail', undefined, 5000);
                    })
                    .done(function (data) {
                        if (data.success) {
                            var message = 'Данные успешно сохранены.';
                            if (data.message) {
                                message = data.message;
                            }
                            Toasts.pushToast(message, 'success', undefined, 5000);
                        }
                    })
                    .always(function() {
                        Modal.closeModal('viber-modal');
                    })
                ;

            });
        }
    });
});